import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LotPopupService } from './lot-popup.service';
import { JhiEventManager } from '../../shared/core-utils';
import { LotService } from '../../shared/inventory/service/lot.service';
import { Lot } from '../../shared/inventory/model/lot.model';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-delete-dialog',
    templateUrl: './lot-delete-dialog.component.html'
})
export class LotDeleteDialogComponent implements OnDestroy {

    lot: Lot;
    subscriptionsManager = new SubscriptionsManager();

    constructor(
        private lotService: LotService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager
    ) {
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.subscriptionsManager.add = this.lotService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'lotListModification',
                content: 'Deleted an lot'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-lot-delete-popup',
    template: ''
})
export class LotDeletePopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lotPopupService: LotPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.lotPopupService
                .open(LotDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}
